export const KPI_SERVICE_COMPLIANCE = ({ processedDashboardData, targetServiceCompliance, isServiceAllowed, handleChangeTab, theme }) => {
    const computedServicePercentage = Math.round(((processedDashboardData?.serviceStats?.inDate || 0) / 
    (((processedDashboardData?.serviceStats?.inDate || 0) + (processedDashboardData?.serviceStats?.overdue || 0)) || 1) * 100)) || 0;
    const isServiceCompliant = computedServicePercentage >= targetServiceCompliance;
    
    return (
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden',
            cursor: isServiceAllowed ? 'pointer' : 'default'
        }}
        onClick={isServiceAllowed ? () => handleChangeTab('service') : null}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: isServiceCompliant ? '#28a745' : '#dc3545'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '13px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 8px 0', letterSpacing: '0.5px' }}>
                        SERVICE COMPLIANCE
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: isServiceCompliant ? '#28a745' : '#dc3545',
                            lineHeight: '1'
                        }}>
                            {computedServicePercentage}%
                        </span>
                        <span style={{
                            fontSize: '18px',
                            color: isServiceCompliant ? '#28a745' : '#dc3545',
                            fontWeight: '500'
                        }}>
                            {isServiceCompliant ? '✓' : '⚠'}
                        </span>
                    </div>
                </div>
                <div style={{
                    background: isServiceCompliant ? 'rgba(40, 167, 69, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                    padding: '12px',
                    borderRadius: '10px',
                    fontSize: '24px'
                }}>
                    🔧
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '12px',
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span>Overdue: {processedDashboardData?.serviceStats?.overdue || 0}</span>
                <span>Up to Date: {processedDashboardData?.serviceStats?.inDate || 0}</span>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: isServiceCompliant ? '#28a745' : '#dc3545',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: {targetServiceCompliance}% • {isServiceCompliant ? 'COMPLIANT' : 'ACTION REQUIRED'}
            </div>
        </div>
    );
}